import { render, staticRenderFns } from "./WaitingForPayment.vue?vue&type=template&id=1e8dd197&"
import script from "./WaitingForPayment.vue?vue&type=script&lang=ts&"
export * from "./WaitingForPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports